// extracted by mini-css-extract-plugin
export default {"LessonEntry":"LessonEntry_LessonEntry__t-1km","LessonEntry__name":"LessonEntry_LessonEntry__name__d9CmX"};